<template>
  <div class="vx-col">
    <vs-card>
      <div class="vx-row">
        <div class="vs-col sm:w-1/2 w-full mb-2">
          <b>Grupo:</b> {{ dadosVeiculo.nomeGrupo }}<br />
          <b>Marca:</b> {{ dadosVeiculo.veiculoMarca }}<br />
          <b>Modelo:</b> {{ dadosVeiculo.veiculoModelo }}<br />
        </div>

        <vs-button
          color="primary"
          type="gradient"
          class="mb-2 text-white forceWhite mr-3"
          @click="liberaAlteraMarcaModelo = true"
        >
          <vs-icon icon-pack="feather" icon="icon-edit"></vs-icon>
        </vs-button>
      </div>
    </vs-card>
    <form role="form" @submit.stop.prevent="emitForm()">
      <div div class="vx-row">
        <div
          v-if="false"
          class="gap-4 items-center w-full vs-col justify-end flex"
        >
          <vs-switch
            nome="isTaxiOrApp"
            id="isTaxiOrApp"
            color="primary"
            v-model="form.isTaxiOrApp"
            :disabled="form.codTipoVeiculo === tipoVeiculo.CAMINHAO"
          >
            <span slot="on"></span>
            <span slot="off"></span>
          </vs-switch>
          <span class="label-switch">Táxi/APP</span>
        </div>
        <div class="vx-col sm:w-1/1 w-full mb-2 card">
          <vs-card v-if="liberaAlteraMarcaModelo">
            <div>
              <div class="vx-col sm:w-1/1 w-full mb-2">
                <vs-select
                  v-model="form.veiculo.idGrupo"
                  :label="`Grupo (${dadosVeiculo.nomeGrupo})`"
                  class="select-large w-full"
                  name="Grupo"
                  autocomplete
                  @change="selecionaTipo(), preencheMarca()"
                  :state="validateState('Grupo')"
                  :danger="validateClass('Grupo')"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.label"
                    v-for="(item, index) in grupos"
                  />
                </vs-select>
              </div>
              <vs-alert
                v-if="liberaAlteraMarcaModelo && !form.veiculo.idGrupo"
                color="primary"
                title="Atenção!!"
                active="true"
                class="my-3"
                style="height: auto !important"
              >
                Para alterar dados de Marca, Modelo e Ano é necessário
                selecionar o Grupo
              </vs-alert>
              <div
                v-if="form.veiculo.idGrupo"
                class="vx-col sm:w-1/1 w-full mb-2"
              >
                <vs-select
                  v-model="form.veiculo.marca"
                  :label="`Marca (${dadosVeiculo.veiculoMarca})`"
                  class="select-large w-full"
                  name="Marca"
                  autocomplete
                  @change="preencheModelo"
                  v-validate="{ required: true }"
                  :state="validateState('Marca')"
                  :danger="validateClass('Marca')"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in marcas"
                  />
                </vs-select>
              </div>
              <div
                v-if="form.veiculo.marca"
                class="vx-col sm:w-1/1 w-full mb-2"
              >
                <vs-select
                  v-model="form.veiculo.modelo"
                  :label="`Modelo (${dadosVeiculo.veiculoModelo})`"
                  class="select-large w-full"
                  name="Modelos"
                  autocomplete
                  @change="preencheAnos"
                  v-validate="{ required: true }"
                  :state="validateState('Modelos')"
                  :danger="validateClass('Modelos')"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in modelos"
                  />
                </vs-select>
              </div>
              <div
                v-if="form.veiculo.modelo"
                class="vx-col sm:w-1/1 w-full mb-2"
              >
                <vs-select
                  v-model="form.veiculo.anoGeral"
                  :label="`Ano Modelo (${
                    dadosVeiculo.AnoModelo == '32000'
                      ? 'OKM'
                      : dadosVeiculo.AnoFabricacao
                  })`"
                  class="select-large w-full"
                  name="Ano Modelo"
                  @change="selecionaAnoModelo"
                  v-validate="{ required: true }"
                  :state="validateState('Ano Modelo')"
                  :danger="validateClass('Ano Modelo')"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in anosModelo"
                  />
                </vs-select>
              </div>
              <div
                v-if="form.veiculo.anoGeral"
                class="vx-col sm:w-1/1 w-full mb-2"
              >
                <vs-select
                  v-model="form.veiculo.anoFabricacao"
                  :label="`Ano Fabricação (${
                    dadosVeiculo.AnoFabricacao == '32000'
                      ? 'OKM'
                      : dadosVeiculo.AnoFabricacao
                  })`"
                  class="select-large w-full"
                  name="Ano Fabricação"
                  @change="buscaValorFipe"
                  v-validate="{ required: true }"
                  :state="validateState('Ano Fabricação')"
                  :danger="validateClass('Ano Fabricação')"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in anosFabricacao"
                  />
                </vs-select>
              </div>
            </div>
          </vs-card>
        </div>
        <div class="vx-col sm:w-3/3 w-full mb-2 card">
          <vs-card>
            <div class="vx-row">
              <div
                v-if="$can('Editar Regional', 'Veículos')"
                class="vx-col sm:w-1/2 w-full mb-2"
              >
                <span>Regional</span>
                <v-select
                  :options="regionais"
                  name="Regional"
                  id="Regional"
                  v-model="form.idRegional"
                  :reduce="(item) => item.id"
                  v-validate="{ required: true }"
                  :state="validateState('Regional')"
                  :class="validateClass('Regional')"
                  @input="buscaDivisoes()"
                ></v-select>
              </div>
              <div
                v-if="$can('Editar Regional', 'Veículos')"
                class="vx-col sm:w-1/2 w-full mb-2"
              >
                <span>Divisão</span>
                <v-select
                  :options="divisoes"
                  name="Regional"
                  id="Regional"
                  v-model="form.id_divisao"
                  :reduce="(item) => item.id"
                  v-validate="{ required: true }"
                  :state="validateState('Regional')"
                  :class="validateClass('Regional')"
                ></v-select>
              </div>
            </div>
            <div class="vx-row">
              <div
                v-if="$can('Editar Classificações', 'Veículos')"
                class="vx-col sm:w-1/2 w-full mb-2"
              >
                <label for="Classificação" class="vs-select--label"
                  >Classificação</label
                >
                <v-select
                  :options="listClassificacoes"
                  name="Classificação"
                  id="Classificação"
                  label="nome"
                  v-model="form.idClassificacao"
                  class="select-large w-full"
                  :reduce="(item) => item.idClassificacao"
                  :state="validateState('Classificação')"
                  :danger="validateClass('Classificação')"
                ></v-select>
              </div>
              <div
                class="vx-col sm:w-1/2 w-full mb-2"
                v-if="exigirCampoEstacionamentoProposta"
              >
                <label for="tipoEstacionamento" class="vs-select--label"
                  >Você possui garagem para guarda do veículo?</label
                >
                <v-select
                  :options="listLocaisEstacionamento"
                  name="Você possui garagem para guarda do veículo?"
                  id="tipoEstacionamento"
                  label="nome"
                  v-model="form.idTipoEstacionamento"
                  class="select-large w-full"
                  :reduce="(item) => item.idTipoEstacionamento"
                  :state="
                    validateState('Você possui garagem para guarda do veículo?')
                  "
                  :danger="
                    validateClass('Você possui garagem para guarda do veículo?')
                  "
                ></v-select>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-input
                  class="w-full"
                  label="Placa"
                  v-mask="'AAA-#XX#'"
                  v-model="form.placa"
                  name="Placa"
                  v-validate="{ min: 8 }"
                  :state="validateState('Placa')"
                  :danger="validateClass('Placa')"
                />
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-input
                  class="w-full"
                  label="Cota"
                  v-model="form.cotaTabela"
                  name="Cota"
                  v-validate="{ required: true, min: 1 }"
                  :state="validateState('Cota')"
                  :danger="validateClass('Cota')"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <label for="" class="vs-input--label">Valor Fipe</label>
                <money
                  class="w-full vs-inputx vs-input--input normal"
                  name="Valor Fipe"
                  id="Valor Fipe"
                  v-model="form.valorFipe"
                  v-validate="{ required: true, min_value: 0.01 }"
                  :state="validateState('Valor Fipe')"
                  :danger="validateClass('Valor Fipe')"
                  v-bind="money"
                ></money>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <label for="" class="vs-input--label">Valor Cobertura</label>
                <money
                  class="w-full vs-inputx vs-input--input normal"
                  name="Valor Cobertura"
                  id="Valor Cobertura"
                  v-model="form.valorCobertura"
                  v-validate="{ required: true, min_value: 0.01 }"
                  :state="validateState('Valor Cobertura')"
                  :danger="validateClass('Valor Cobertura')"
                  v-bind="money"
                ></money>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-input
                  class="w-full"
                  label="Renavam"
                  type="number"
                  v-model="form.renavam"
                  name="Renavam"
                  v-validate="{ required: true }"
                  :state="validateState('Renavam')"
                  :danger="validateClass('Renavam')"
                />
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-input
                  class="w-full"
                  label="Chassi"
                  v-model="form.chassi"
                  name="Chassi"
                  v-validate="{ required: true, min: 17 }"
                  :state="validateState('Chassi')"
                  :danger="validateClass('Chassi')"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <vs-input
                  class="w-full"
                  label="KM"
                  type="number"
                  v-model="form.km"
                  name="KM"
                  v-validate="{ required: true }"
                  :state="validateState('KM')"
                  :danger="validateClass('KM')"
                />
              </div>
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <vs-input
                  v-if="exibeCilindrada || this.form.cilindradas"
                  class="w-full"
                  type="number"
                  label="Cilindradas"
                  v-model="form.cilindradas"
                  name="Cilindradas"
                  v-validate="{ required: true }"
                  :state="validateState('Cilindradas')"
                  :danger="validateClass('Cilindradas')"
                />
                <vs-input
                  v-else
                  class="w-full"
                  label="Portas"
                  type="number"
                  v-model="form.qtdPortas"
                  name="Portas"
                  :state="validateState('Portas')"
                  :danger="validateClass('Portas')"
                />
              </div>
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <vs-input
                  class="w-full"
                  label="Ano CRLV"
                  type="number"
                  v-model="form.anoExercicioDut"
                  name="Ano CRLV"
                  v-validate="{ required: true }"
                  :state="validateState('Ano CRLV')"
                  :danger="validateClass('Ano CRLV')"
                />
              </div>
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <vs-input
                  class="w-full text-transform: uppercase"
                  label="Número do Motor"
                  v-model="form.numeroMotor"
                  name="Número do Motor"
                  v-validate="{ required: true }"
                  :state="validateState('Número do Motor')"
                  :danger="validateClass('Número do Motor')"
                />
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <label for="Estado do Pneu" class="vs-select--label"
                  >Estado do Pneu</label
                >

                <v-select
                  :options="estadoPneus"
                  name="Estado do Pneu"
                  id="Estado do Pneu"
                  label="label"
                  v-model="form.estadoPneu"
                  class="select-large w-full v-select--large"
                  :state="validateState('Estado do Pneu')"
                  :danger="validateClass('Estado do Pneu')"
                ></v-select>
              </div>
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <label for="Combustivel" class="vs-select--label"
                  >Combustivel</label
                >

                <v-select
                  :options="combustiveis"
                  name="Combustivel"
                  id="Combustivel"
                  label="label"
                  v-model="form.combustivel"
                  class="select-large w-full v-select--large"
                  :reduce="(item) => item.id"
                  :state="validateState('Combustivel')"
                  :danger="validateClass('Combustivel')"
                ></v-select>
              </div>
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <label for="Cor" class="vs-select--label">Cor</label>

                <v-select
                  :options="cores"
                  name="Cor"
                  id="Cor"
                  label="label"
                  v-model="form.cor"
                  class="select-large w-full v-select--large"
                  :reduce="(item) => item.id"
                  :state="validateState('Cor')"
                  :danger="validateClass('Cor')"
                ></v-select>
              </div>
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <label for="Tipo de Câmbio" class="vs-select--label"
                  >Tipo de Câmbio</label
                >
                <v-select
                  :options="tipoCambioOpcoes"
                  name="Tipo de Câmbio"
                  id="Tipo de Câmbio"
                  label="label"
                  v-model="form.tipoCambio"
                  class="select-large w-full"
                  :state="validateState('Tipo de Câmbio')"
                  :danger="validateClass('Tipo de Câmbio')"
                ></v-select>
              </div>
            </div>

            <div class="vx-row mt-4 mb-4" v-if="!verificaEmpresaBemProtege">
              <!-- Participa do Rateio -->
              <div
                class="vx-col sm:w-1/3 w-full mb-2"
                v-if="!verificaEmpresaBemProtege"
              >
                <span>Participa do Rateio?</span>
                <vs-switch
                  color="success"
                  v-model="form.participaRateio"
                  style="width: 60px"
                  :disabled="!permissaoAlterarDadosCobranca"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>

              <!-- Boleto Físico -->
              <div
                class="vx-col sm:w-1/3 w-full mb-2"
                v-if="!verificaEmpresaBemProtege"
              >
                <span>Boleto Físico?</span>
                <vs-switch
                  color="success"
                  v-model="form.boletoFisico"
                  style="width: 60px"
                  :disabled="!permissaoAlterarDadosCobranca"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col sm:w-1/1 w-full mb-2">
                <vs-textarea label="Observações" v-model="form.observacao" />
              </div>
            </div>

            <div class="vx-row">
              <!-- vendedor -->
              <div class="vx-col lg:w-1/2 w-full mb-2">
                <label for="" class="vs-select--label">Vendedor</label>
                <v-select
                  :options="vendedores"
                  name="Vendedor"
                  label="label"
                  id="idUsuario"
                  v-model="form.vendedorInicial"
                  class="select-large w-full"
                  :reduce="(item) => item.nome"
                  :state="validateState('Vendedor')"
                  :danger="validateClass('Vendedor')"
                ></v-select>
              </div>

              <!-- Data de Ativação -->
              <div
                class="vx-col sm:w-1/2 w-full"
                v-if="$can('Alterar Data de Ativação', 'Veículos')"
              >
                <label class="vs-input--label">Data de Ativação Real</label>
                <div>
                  <flat-pickr
                    name="Data de Ativação"
                    class="input-data-ativacao"
                    v-model="form.dataAdesaoRealAux"
                    :state="validateState('Data de Ativação')"
                    :class="validateClass('Data de Ativação')"
                    :config="configdateTimePickerDay"
                    placeholder="DD/MM/AAAA"
                  />
                </div>
              </div>
            </div>

            <div
              class="vx-row"
              v-if="restricoes.length > 0 && permitirRestricoes"
            >
              <div class="vx-col sm:w-1/1 w-full mb-2">
                <label for="" class="vs-select--label">Restrições</label>
                <v-select
                  :options="restricoes"
                  name="Restrições"
                  label="descricao"
                  v-model="restricoesSelecionadas"
                  class="select-large w-full"
                  :reduce="(item) => item.idRestricao"
                  multiple
                  :state="validateState('Restrições')"
                  :danger="validateClass('Restrições')"
                  @input="selecionaRestricoes()"
                ></v-select>
              </div>
            </div>
          </vs-card>
          <vs-alert
            v-if="$validator.errors.all().length > 0"
            color="danger"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
          >
            <ul>
              <li
                class="mb-2"
                v-for="error in $validator.errors.all()"
                :key="error.id"
              >
                {{ error }}
              </li>
            </ul>
          </vs-alert>
          <div class="vx-row">
            <div class="vx-col w-full text-right">
              <BotaoSubmit
                variant="success"
                :edit="true"
                :aguarde="aguardeCadastro"
              ></BotaoSubmit>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import service from './../../services';
import moment from 'moment';
import functions from '../../utils/functions';

import BotaoSubmit from '../../components/BotaoSubmit';
import vSelect from 'vue-select';
import { Money } from 'v-money';
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import regionaisService from './../../services/regionais';
import notify from './../../utils/notify';
import estacionamentoService from '../../services/estacionamento';
import { decryptData } from './../../services/decryptData';
import { TIPO_VEICULO } from '../../commons/constant/tipo-veiculo';

export default {
  props: [
    'dadosVeiculo',
    'formulario',
    'grupos',
    'combustiveis',
    'cores',
    'formasPagamentos',
    'restricoes',
    'vendedores',
    'permitirRestricoes',
    'exigirCampoEstacionamentoProposta',
  ],
  watch: {
    dadosVeiculo() {
      this.preencheForm();
    },
  },
  components: {
    Money,
    BotaoSubmit,
    'v-select': vSelect,
    flatPickr,
  },
  data() {
    return {
      vendedoresIniciais: [],
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
      },
      selecionouRestricao: false,
      aguardeCadastro: false,
      exibeCilindrada: false,
      forcarAtualizacao: false,
      codigoTabelaReferencia: null,
      liberaAlteraMarcaModelo: false,
      tiposVeiculos: [],
      marcas: [],
      modelos: [],
      modelosAux: [],
      anosModelo: [],
      anosFabricacao: [],
      restricoesSelecionadas: [],
      listClassificacoes: [],
      listLocaisEstacionamento: [],
      divisoes: [],
      regionais: [],
      tipoCambioOpcoes: ['Automático', 'Manual'],
      estadoPneus: ['Ruim', 'Regular', 'Bom', 'Novo'],
      form: {
        vendedorInicial: null,
        idVeiculo: null,
        placa: null,
        renavam: null,
        chassi: null,
        km: null,
        qtdPortas: null,
        anoExercicioDut: null,
        estadoPneu: null,
        combustivel: null,
        cor: null,
        cilindradas: null,
        cotaTabela: null,
        observacao: null,
        participaRateio: null,
        boletoFisico: null,
        restricoesSelecionadas: null,
        valorFipe: null,
        valorCobertura: null,
        tipoCambio: null,
        numeroMotor: null,
        dataAdesaoReal: null,
        dataAdesaoRealAux: null,
        id_divisao: null,
        idRegional: null,
        idClassificacao: null,
        idTipoEstacionamento: null,
        isTaxiOrApp: null,
        codTipoVeiculo: null,
        veiculo: {
          idGrupo: null,
          tipoVeiculo: null,
          codigoMarca: null,
          codigoModelo: null,
          anoGeral: null,
          anoModelo: null,
          anoFabricacao: null,
          codigoTipoCombustivel: null,
          combustivel: null,
          marca: null,
          modelo: null,
          codigoFipe: null,
          ano: null,
          resultFipe: {},
          numeroMotor: null,
          tipoCambio: null,
        },
      },
      diasDeVencimentoEmpresa: null,
      idEmpresa: null,

      // Configurações de Component
      configdateTimePickerDay: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
      tipoVeiculo: TIPO_VEICULO,
    };
  },
  computed: {
    permissaoAlterarDadosCobranca() {
      return this.$can('Editar Dados Cobrança', 'Veículos');
    },
    verificaEmpresaBemProtege() {
      return functions.verificaEmpresaBemProtege(this.idEmpresa);
    },
  },
  methods: {
    buscarFipeAtualizada() {
      this.$vs.loading();
      var resultDados = JSON.parse(
        this.dadosVeiculo.dadosVeiculo.resultadoFipe,
      );
      var formFipe = {
        codigoTabelaReferencia: null,
        codigoTipoVeiculo: resultDados.tipo,
        codigoMarca: resultDados.id_marca,
        ano: resultDados.id_modelo_ano,
        codigoTipoCombustivel: resultDados.id_modelo_ano.split('-')[1],
        anoModelo: resultDados.ano_modelo,
        codigoModelo: resultDados.id_modelo,
      };
      service
        .post('Fipe', `ConsultarValorComTodosParametros`, formFipe)
        .then((res) => {
          this.form.veiculo.resultFipe = res.data;
          this.$vs.loading.close();
        });
    },
    selecionaRestricoes() {
      this.selecionouRestricao = true;
      this.form.restricoesSelecionadas = [];
      this.restricoesSelecionadas.forEach((element) => {
        this.form.restricoesSelecionadas.push(element);
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    keymonitor: function () {
      if (this.form.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.form.cep.replace('.', '').replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            res.data = decryptData(res.data);
            this.form.endereco = res.data.street;
            this.form.bairro = res.data.neighborhood;
            this.form.cidade = res.data.city;
            this.form.estado = res.data.state;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    selecionaTipo() {
      var aux = this.grupos.find((x) => x.idGrupo == this.form.veiculo.idGrupo);
      this.form.veiculo.tipoVeiculo = aux.idTipoFipe;
      if (aux.idTipoFipe == 2) {
        this.exibeCilindrada = true;
      } else {
        this.exibeCilindrada = false;
      }
    },
    preencheMarca() {
      var obj = { idGrupo: {} };
      obj.idGrupo.id = this.form.veiculo.idGrupo;
      this.form.veiculo.marca = null;
      this.form.veiculo.modelo = null;
      this.form.veiculo.anoGeral = null;
      this.form.veiculo.anoFabricacao = null;
      this.form.cilindradas = null;
      this.marcas = [];
      this.modelos = [];
      this.anosModelo = [];
      this.anosFabricacao = [];
      this.$vs.loading();
      service
        .post('Cotacao', 'ConsultaMarcasModeloPorGrupo', obj)
        .then((res) => {
          this.$vs.loading.close();
          if (res.data.length > 0) {
            this.isGrupoModelos = true;
            this.marcas = [];
            this.modelosAux = [];
            res.data.forEach((element) => {
              var aux = this.marcas.filter(
                (x) => x.value.id == element.idMarca,
              );
              var auxModelos = this.modelosAux.filter(
                (y) => y.value.id == element.idModelo,
              );
              if (aux.length == 0)
                this.marcas.push({
                  value: {
                    id: element.idMarca,
                    valor: element.marca,
                    isGrupoModelos: true,
                  },
                  text: element.marca,
                });

              if (auxModelos.length == 0)
                this.modelosAux.push({
                  idMarca: element.idMarca,
                  idTipo: element.idTipo,
                  value: {
                    id: element.idModelo,
                    valor: element.modelo,
                    isGrupoModelos: true,
                  },
                  text: element.modelo,
                });
            });
            this.buscaDadosFipe('ConsultarMarcas', 'marcas', 'name', 'id');
          } else {
            this.isGrupoModelos = false;
            this.buscaDadosFipe('ConsultarMarcas', 'marcas', 'name', 'id');
          }
        });
    },
    preencheModelo() {
      this.modelos = [];
      this.anosModelo = [];
      this.anosFabricacao = [];
      this.form.marca;
      this.form.veiculo.codigoMarca = this.form.veiculo.marca.id;
      this.form.veiculo.modelo = null;
      this.form.veiculo.anoGeral = null;
      this.form.veiculo.anoFabricacao = null;
      this.form.cilindradas = null;
      this.selecionaTipo();
      if (!this.form.veiculo.marca.isGrupoModelos) {
        this.buscaDadosFipe('ConsultarModelos', 'modelos', 'name', 'id');
      } else {
        this.modelos = this.modelosAux.filter(
          (x) => x.idMarca == this.form.veiculo.marca.id,
        );
      }
    },
    async preencheAnos() {
      this.form.veiculo.anoGeral = null;
      this.form.veiculo.anoFabricacao = null;
      this.form.cilindradas = null;
      if (this.form.veiculo.marca.isGrupoModelos == true) {
        var modeloAux = this.modelosAux.find(
          (x) => x.value.id == this.form.veiculo.modelo.id,
        );
        this.form.veiculo.tipoVeiculo = modeloAux.idTipo;
      }

      this.anosModelo = [];
      this.anosFabricacao = [];
      this.form.veiculo.codigoModelo = this.form.veiculo.modelo.id;
      await this.buscaDadosFipe(
        'ConsultarAnoModelo',
        'anosModelo',
        'name',
        'id',
      );

      var auxAnos = [];

      this.anosModelo.forEach((element) => {
        if (element.value) {
          var ano = element.value.valor.split(' ')[0];
          var combustivel = element.value.valor.split(' ')[1];
          var codigoTipoCombustivel = element.value.id.split('-')[1];
          this.anosFabricacao.push({
            value: ano,
            text: ano,
          });
          auxAnos.push({
            value: {
              ano: ano,
              combustivel: combustivel,
              codigoTipoCombustivel: codigoTipoCombustivel,
            },
            text: element.value.valor,
          });
        }
      });
      this.anosModelo = auxAnos;
      this.anosModelo.unshift({ text: 'Selecione', value: null });
    },
    selecionaAnoModelo() {
      this.form.veiculo.ano = this.form.veiculo.anoGeral.ano;
      this.form.veiculo.codigoTipoCombustivel =
        this.form.veiculo.anoGeral.codigoTipoCombustivel;
      this.form.veiculo.anoModelo = this.form.veiculo.anoGeral.ano;
      this.form.veiculo.combustivel = this.form.veiculo.anoGeral.combustivel;

      this.form.veiculo.anoFabricacao = null;
      this.form.cilindradas = null;

      const _anoAnterior =
        this.form.veiculo.anoModelo == '0KM'
          ? {}
          : {
              value: this.form.veiculo.anoModelo - 1,
              text: this.form.veiculo.anoModelo - 1,
            };

      this.anosFabricacao = [
        {
          value: this.form.veiculo.anoModelo,
          text: this.form.veiculo.anoModelo,
        },
        {
          ..._anoAnterior,
        },
      ];

      this.anosFabricacao.unshift({ text: 'Selecione', value: null });
      this.anosFabricacao = this.anosFabricacao.filter((ano) => ano.value);
    },
    buscaValorFipe() {
      this.buscaDadosFipe(
        'ConsultarValorComTodosParametros',
        'form.veiculo.resultFipe',
        '',
        '',
      );
    },
    buscaDadosFipe(action, array, campoDescricao, campoPK) {
      return new Promise(async (resolve) => {
        this.$vs.loading();
        var formFipe = {
          codigoTabelaReferencia: this.codigoTabelaReferencia,
          codigoTipoVeiculo: this.form.veiculo.tipoVeiculo,
          codigoMarca: this.form.veiculo.codigoMarca,
          ano:
            this.form.veiculo.anoModelo +
            '-' +
            this.form.veiculo.codigoTipoCombustivel,
          codigoTipoCombustivel: this.form.veiculo.codigoTipoCombustivel,
          anoModelo: this.form.veiculo.anoModelo,
          codigoModelo: this.form.veiculo.codigoModelo,
        };

        service.post('Fipe', `${action}`, formFipe).then((res) => {
          const arrayRes = array == 'modelos' ? res.data[0] : res.data;

          if (array == 'form.veiculo.resultFipe') {
            this.form.veiculo.resultFipe = arrayRes;
            this.$vs.loading.close();
            resolve();
            return;
          }
          this[array] = [];
          this[array].push({ text: 'Selecione', value: null });
          arrayRes.forEach((element) => {
            if (array == 'codigoTabelaReferencia') {
              this[array] = element[campoPK];
            } else {
              if (array == 'anosModelo') {
                element['name'] = element.name.replace('32000', '0KM');
              }
              if (element[campoPK])
                this[array].push({
                  value: {
                    id: element[campoPK],
                    valor: element[campoDescricao],
                  },
                  text: element[campoDescricao],
                });
              else this[array].push(element);
            }
          });
          this.$vs.loading.close();
          resolve();
        });
      });
    },

    preencheForm() {
      this.form.id_veiculo = this.dadosVeiculo.id_veiculo;
      this.form.cilindradas = this.dadosVeiculo.cilindradas;
      this.form.placa = this.dadosVeiculo.placa;
      this.form.renavam = this.dadosVeiculo.renavam;
      this.form.chassi = this.dadosVeiculo.chassi;
      this.form.km = this.dadosVeiculo.km;
      this.form.qtdPortas = this.dadosVeiculo.qtdPortas;
      this.form.anoExercicioDut = this.dadosVeiculo.anoExercicioDut;
      this.form.estadoPneu = this.dadosVeiculo.estadoPneu;
      this.form.combustivel = this.dadosVeiculo.combustivel;
      this.form.cor = this.dadosVeiculo.cor;
      this.form.cotaTabela = this.dadosVeiculo.cotaTabela;
      this.form.observacao = this.dadosVeiculo.observacao;
      this.form.participaRateio = this.dadosVeiculo.participaRateio;
      this.form.boletoFisico = this.dadosVeiculo.boletoFisico;
      this.form.valorFipe = this.dadosVeiculo.valorFipe;
      this.form.valorCobertura = this.dadosVeiculo.valorCobertura;
      this.form.numeroMotor = this.dadosVeiculo.numeroMotor;
      this.form.tipoCambio = this.dadosVeiculo.tipoCambio;
      this.form.idClassificacao = this.dadosVeiculo.idClassificacao;
      this.form.idRegional = this.dadosVeiculo.idRegional;
      this.form.id_divisao = this.dadosVeiculo.id_divisao;
      this.form.idTipoEstacionamento = this.dadosVeiculo.idTipoEstacionamento;
      this.form.isTaxiOrApp = this.dadosVeiculo.isTaxiOrApp;
      this.form.codTipoVeiculo = this.dadosVeiculo.codTipoVeiculo;
      this.form.dataAdesaoRealAux = !this.dadosVeiculo.dataAdesaoReal
        ? null
        : moment(this.dadosVeiculo.dataAdesaoReal).utc().format('DD/MM/YYYY');

      if (this.dadosVeiculo.vendedor_inicial) {
        this.form.vendedorInicial = [
          {
            id: this.dadosVeiculo.vendedor_inicial,
            label: this.dadosVeiculo.vendedor_inicial,
          },
        ];
      }

      this.restricoesSelecionadas = [];

      if (this.dadosVeiculo.restricoes) {
        this.dadosVeiculo.restricoes.forEach((element) => {
          this.restricoesSelecionadas.push(element.id_restricao);
        });
      }

      this.idEmpresa = this.dadosVeiculo.id_empresa;
      this.buscaDadosRegionais();
      this.selecionaRestricoes();
    },
    emitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var newForm = {
            veiculo: {},
          };
          this.form.dataAdesaoReal = moment(
            this.form.dataAdesaoRealAux,
            'DD/MM/YYYY',
          ).format('YYYY-MM-DD');

          Object.keys(this.form).forEach((element) => {
            if (
              (typeof this.form[element] != 'object' &&
                typeof this.form[element] != 'undefined') ||
              typeof this.form[element] === 'boolean'
            ) {
              if (this.form[element] != this.dadosVeiculo[element]) {
                newForm[element] = this.form[element];
              }
            }
          });

          Object.keys(this.form.veiculo).forEach((element) => {
            if (this.form.veiculo[element] != null) {
              newForm.veiculo[element] = this.form.veiculo[element];
            }
          });

          var restricoesAntigas = '';
          var restrocoesNovas = '';

          if (this.dadosVeiculo.restricoes) {
            restricoesAntigas = this.dadosVeiculo.restricoes.toString();
          }

          if (this.restricoesSelecionadas.length > 0) {
            restrocoesNovas = this.form.restricoesSelecionadas.toString();
          }

          if (restricoesAntigas != restrocoesNovas) {
            newForm.restricoesSelecionadas = this.form.restricoesSelecionadas;
          }

          newForm.idVeiculo = this.form.id_veiculo;

          this.$emit('formAlterado', newForm);
        } else {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Existem campos não preenchidos',
            color: 'danger',
          });
        }
      });
    },
    preencheVendedoresIniciais() {
      this.vendedores.forEach((consultor) => {
        const { nome: id, label } = consultor;
        this.vendedoresIniciais.push({
          id,
          label,
        });
      });
    },
    async buscaClassificacoes() {
      try {
        const result = await service.post(
          'classificacoes',
          'listClassificacoes',
          {},
        );
        this.listClassificacoes = result.data;
      } catch (error) {
        throw new Error(error);
      }
    },
    async buscaDadosRegionais() {
      this.$vs.loading();
      this.regionais = [];
      let objSend = {};
      objSend.idEmpresa = !this.$route.params.idEmpresa
        ? this.form.idEmpresa
        : this.$route.params.idEmpresa;

      try {
        this.regionais = await regionaisService.buscaRegionaisUsuario(
          this.id_usuario,
          objSend,
        );
        //this.form.idRegional = this.regionais[0].id;
      } catch (e) {
        notify.notifyFail(this.$vs, 'Falha ao buscar os Regionais e Divisões');
      }
      this.idRegionais = this.regionais.map((item) => item.id);
      this.buscouRegionais = true;
      this.$vs.loading.close();
      this.buscaDivisoes();
    },
    async buscaDivisoes() {
      if (this.form.idRegional) {
        var objSend = {
          idRegional: this.form.idRegional,
        };

        objSend.idEmpresa = !this.$route.params.idEmpresa
          ? this.form.idEmpresa
          : this.$route.params.idEmpresa;

        this.$vs.loading();
        try {
          const divisoes = await regionaisService.buscaDivisoes(objSend);
          this.divisoes = divisoes;
        } catch (e) {
          notify.notifyFail(
            this.$vs,
            'Falha ao buscar os Regionais e Divisões',
          );
        }
        //this.form.id_divisao = this.divisoes[0].id;
        this.$vs.loading.close();
        this.buscouDivisoes = true;
        this.$vs.loading.close();
      }
    },

    async buscaDadosTiposEstacionamento() {
      try {
        this.$vs.loading();
        const result = await estacionamentoService.buscar();
        this.listLocaisEstacionamento = result.data;
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Não foi possível buscar os locais de estacionamento, tente novamente',
          'Atenção',
          'danger',
          5000,
        );
      } finally {
        this.$vs.loading.close();
      }
    },
  },

  mounted() {
    this.preencheForm();
    this.buscaClassificacoes();
    this.buscaDadosTiposEstacionamento();

    //this.preencheVendedoresIniciais();
  },
};
</script>
<style scoped lang="scss">
.vdp-datepicker input {
  width: 100%;
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>

<style>
.input-data-ativacao {
  padding: 7px !important;
  width: 100%;
}
</style>
